module.exports = __webpack_public_path__ + "static/media/Loader.0e7dbca3.gif";